import styled from "@emotion/styled";

import crossLines from "./CrossLines.png";

export const Root = styled.div({
    position: "relative",
    width: 410,
    height: 380,
    overflow: "hidden",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "100%",
    textAlign: "center",
    backgroundImage: `url(${crossLines})`,
});

export const AlignHack = styled.div({
    display: "inline-block",
    height: "100%",
    verticalAlign: "middle",
});

export const Text = styled.div(props => ({
    backgroundColor: props.theme.candy.keyPalette.primaryBackgroundColor,
    fontSize: 14,
    color: props.theme.candy.typography.primary.color,
    lineHeight: "22px",
    textAlign: "center",
    height: 60,
    paddingTop: 15,
    display: "inline-block",
    verticalAlign: "middle",
}));
